import Login from "@/features/auth/Login";
import ForgotPassword from "@/features/auth/ForgotPassword";
import ResetPassword from "@/features/auth/ResetPassword";
import CheckOtp from "@/features/auth/CheckOtp";

export const authRoutes = [
  { path: "/login", element: <Login /> },
  { path: "/forget-password", element: <ForgotPassword /> },
  { path: "/check-otp", element: <CheckOtp /> },
  { path: "/reset-password", element: <ResetPassword /> },
];
